import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import CampaignStepper from './CampaignStepper'
import CustomerToTarget from './CustomerToTarget';
import ProductDetails from './ProductDetails';
import SetGoal from './SetGoal';
import VisibilityDetails from './VisibilityDetailsV0';
import initState, { validateAll } from '../../utils/stateHandler';
import CreativeAssets from './CreativeAssets';
import CampaignSummary from '../../components/CampaignSummary';
import { defaults, stepperHeading, steps, createCampaignQuery} from './constants';
import { getAttributes, createNewCampaign, getProductSegment, setStep, setTargetCustomerCount, setViewCampaignSelected } from './createCampaignReducer'
import { showSummaryAction, hideSummaryAction } from '../../components/CampaignSummary/campaignSummaryReducer'
import { formRequestBody, getComment, getDefaultStateFromSelectedListing, getUpdateCampaignPayload } from './helpers';
import { writeSummary, getMillisFromDateTimeMoment, writeProductDetailSummary } from '../../utils/utils';
import { SEVEARITY_CONTS, showNudge } from '../../components/Nudge/nudgeReducer';
import moment from 'moment';
import { campaignCTAs, CAMPAIGN_STATUSES } from '../../utils/constants';
import CallOutDetails from './CallOutDetsils';
import { bannerLinkSelector } from './selector';

const CreateCampaigns = () => {
    const store = useSelector(store => store.createCampaign)
    const dispatch = useDispatch()

    let createCampaignData = defaults
    if (store.viewCampaignSelected) {
        createCampaignData = getDefaultStateFromSelectedListing(store.viewCampaignSelected, store)
    }
    const [showCreativeAssests, setShowCreativeAssests] = React.useState(false);
    const [step1State, step1Setters, step1Handlers] = initState(steps[0])(createCampaignData.step1State, initializeWhileSetState(steps[0]))
    const [step2State, step2Setters] = initState(steps[1])(createCampaignData.step2State, initializeWhileSetState(steps[1]))
    const [step3State, step3Setters, step3Handlers] = initState(steps[2])(createCampaignData.step3State, initializeWhileSetState(steps[2]))
    const [step4State, step4Setters, step4Handlers] = initState(steps[3])(createCampaignData.step4State, initializeWhileSetState(steps[3]))
    const [step5State, step5Setters, step5Handlers] = initState(steps[4])(createCampaignData.step5State, initializeWhileSetState(steps[4]));
    const [isStepValid, isStepValidSetters] = initState("Validations", true)(createCampaignData.isStepValid);
    const showSummary = useSelector(store => store.campaignSummary.showSummary)
    const { BannerLink : bannerLink } = useSelector(bannerLinkSelector)
    
    const allowedSteps = store?.viewCampaignSelected?.allowedFeatures || [...steps].splice(0,4);
    const activeStep = store?.activeStep || 0;
    
    const setActiveStep = (step) => {
        dispatch(setStep(step));
    }

    const getPossibleCTAs = (staus, callOut, bannerUrl) => {
        switch(staus) {
            case CAMPAIGN_STATUSES.inputReady:
                return [campaignCTAs.edit, campaignCTAs.submitRequest];
            case CAMPAIGN_STATUSES.requested:
                if (bannerUrl) {
                    return [campaignCTAs.edit, campaignCTAs.sendForApproval];
                } else {
                    return [campaignCTAs.edit, campaignCTAs.submitRequest];
                }
            case CAMPAIGN_STATUSES.bannerReady:
                if (callOut) {
                    return [campaignCTAs.edit, campaignCTAs.schedule];
                } else {
                    return [campaignCTAs.edit, campaignCTAs.sendForApproval];
                }
            // case CAMPAIGN_STATUSES.live:
            // case CAMPAIGN_STATUSES.dead:
            // case CAMPAIGN_STATUSES.creationInProgress:
            // case CAMPAIGN_STATUSES.creationFailed:
            // case CAMPAIGN_STATUSES.scheduled:
            // case CAMPAIGN_STATUSES.paused:
            default:
                return [campaignCTAs.edit, campaignCTAs.update];
        }
    }

    const handleShowSummary = () => {
        const campaignStatus = store.viewCampaignSelected ? store.viewCampaignSelected.campaignStatus : CAMPAIGN_STATUSES.inputReady;
        const campaignId = store.viewCampaignSelected ? store.viewCampaignSelected.campaignId : ''
        const createdBy = store.viewCampaignSelected ? store.viewCampaignSelected.createdBy: ''
        dispatch(showSummaryAction({
            goal: step1State.goal,
            campaignName: step1State.campaignName,
            comment: step4State.comment || '',
            // campaignOwner: step1State.campaignOwner,
            // campaignType: step1State.campaignType,
            startTime: getMillisFromDateTimeMoment(step1State.date.from, step1State.time.from),
            endTime: getMillisFromDateTimeMoment(step1State.date.to, step1State.time.to),
            productSegmentQuery: step3State.attributes,
            productQuery : writeProductDetailSummary(step3State),
            bannerUrl: step4State.url,
            plvCallOut: step5State.plvCallOut,
            score: step5State.score,
            customerSegmentQuery: writeSummary(step2State.include),
            possibleCTAs: getPossibleCTAs(campaignStatus, step5State.plvCallOut, step4State.url),
            stateTransitionDTOList: store.viewCampaignSelected?.stateTransitionDTOList || [],
            allowedFeatures: store.viewCampaignSelected?.allowedFeatures || [],
            campaignStatus,
            campaignId,
            createdBy,
            bannerInput: step4State.bannerInput,
            jpins: step4State.jpins
        }))
    }

    const handleEdit = (step = 0) => {
        dispatch(hideSummaryAction())
        setActiveStep(step);
    }

    const onImageError = (e) => {
        dispatch(showNudge({
            message: "No image found",
            type: SEVEARITY_CONTS.error
        }))
    }

    const handleCreateCampaign = (requestType) => {
        const combinedState = {
            step1State,
            step2State,
            step3State,
            step4State,
            step5State
        }
        const campaignData = formRequestBody(combinedState, { customerSegmentData: store.attributeData.data, productSegmentData: store.productSegment.data })
        if (store.viewCampaignSelected && !(store.viewCampaignSelected.isClone)) {
            campaignData.campaignId = store.viewCampaignSelected.campaignId
            campaignData.uinodeId = store.viewCampaignSelected.uinodeId
            // delete campaignData.customerSegmentQueryTree
        }
        if (requestType === campaignCTAs.decline) {
            campaignData.isDecline = true;
        }else {
            campaignData.isDecline = false;
        }
        dispatch(createNewCampaign({
            campaignData,
            requestType
        }))
    }

    const handlePauseCampaign = (summary = store.newCampaign?.data) => {
        dispatch(createNewCampaign({
            campaignData: getUpdateCampaignPayload({ ...summary, comment: getComment(summary), status: "INACTIVE" }),
            requestType: campaignCTAs.pause
        }))
    }

    const handleResumeCampaign = (summary = store.newCampaign?.data) => {
        dispatch(createNewCampaign({
            campaignData: getUpdateCampaignPayload({ ...summary, comment: getComment(summary), status: "ACTIVE" }),
            requestType: campaignCTAs.resume
        }))
    }

    const validate = (value, stateChildKey, stateParentKey, setters) => {
        let isValid = true
        // eslint-disable-next-line default-case
        switch (stateChildKey) {
            case "goal":
            case "campaignName":
            case "totalProducts":
            case "campaignOwner":
            case "campaignType":
            case "plvCallOut":
            case "score":
                if (!value) {
                    isValid = false
                }
                break;
            case "from":
                if ((stateParentKey !== 'time') && (!value || value.isBefore(moment(), "day"))) {
                    isValid = false
                }
                break;
            case "to":
                if (!value || !isStepValid[steps[0]][stateParentKey].from.valid) {
                    isValid = false
                }
                break;
            case "attributes":
                if (stateParentKey === "exclude") {
                    isValid = step2State.isExclude ? validateAll(value, true) : true
                } else {
                    isValid = validateAll(value, true)
                }
                break;
            case "operator":
                isValid = true
                break;
            case 'url':
            case 'bannerLink':
                if(bannerLink && !value) {
                        isValid = false
                } else {
                    isValid = true
                }
                break;
            case "comment":
            case "bannerInput":
            case "jpins":
                isValid = true
                break;
            default:
                break;
        }
        if (stateParentKey) {
            setters[stateParentKey][stateChildKey].valid(isValid)
        } else {
            setters[stateChildKey]?.valid(isValid)
        }
    }
    
    function initializeWhileSetState(step) {
        return function whileSetState(recievedValue, stateChildKey, stateParentKey) {
            let value = recievedValue
            if (recievedValue && recievedValue.fromHandler) {
                value = recievedValue.value
            }
            switch (stateChildKey) {
                case "isExclude":
                    isStepValidSetters[step].exclude.attributes.valid(!value)
                    break;
                case "from":
                    if (!step1State[stateParentKey].to ||
                        recievedValue.toDate().getTime() > step1State[stateParentKey].to.toDate().getTime()) {
                        step1Setters[stateParentKey].to(recievedValue)
                        isStepValidSetters[step][stateParentKey].to.valid(true)
                    }
                    validate(value, stateChildKey, stateParentKey, isStepValidSetters[step])
                    break;
                default:
                    validate(value, stateChildKey, stateParentKey, isStepValidSetters[step])
                    break;
            }
        }
    }

    const renderStep = () => {
        switch (activeStep) {
            case 0:
                return <SetGoal state={step1State} setters={step1Setters} handlers={step1Handlers} validation={isStepValid[steps[0]]} validationSetters={isStepValidSetters[steps[0]]} nextStepValid={validateAll(isStepValid[steps[0]])} nextStepState={step2State} nextStepSetters={step2Setters} />
            case 1:
                return <CustomerToTarget data={store.attributeData.data} state={step2State} setters={step2Setters} validation={isStepValid[steps[1]]}  nextStepValid={validateAll(isStepValid[steps[1]])} validationSetters={isStepValidSetters[steps[1]]} nextStepState={step3State} nextStepSetters={step3Setters} />
            case 2:
                return <ProductDetails data={store.productSegment.data} state={step3State} setters={step3Setters} handlers={step3Handlers} validation={isStepValid[steps[2]]} validationSetters={isStepValidSetters[steps[2]]} />
            case 3:
                return <>
                    <VisibilityDetails state={step4State} setters={step4Setters} handlers={step4Handlers} showCreativeAssests={setShowCreativeAssests} onImageError={onImageError} validation={isStepValid[steps[3]]} validationSetters={isStepValidSetters[steps[3]]} />
                    {showCreativeAssests && <CreativeAssets showSummary={handleShowSummary} />}
                </>
            case 4:
                return <CallOutDetails state={step5State} setters={step5Setters} handlers={step5Handlers} validation={isStepValid[steps[4]]} validationSetters={isStepValidSetters[steps[4]]} />
            default:
                return null;
        }
    }

    React.useEffect(() => {
        const { isClone } = store
        if(!isClone){
            dispatch(getProductSegment({entityType:createCampaignQuery.product}))
            dispatch(getAttributes({entityType:createCampaignQuery.customer}))
        }
        dispatch(setTargetCustomerCount(null));
    }, [dispatch])

    return <>
        {showSummary ?
            <CampaignSummary
                onEdit={handleEdit}
                onSubmit={handleCreateCampaign}
                onPause={handlePauseCampaign}
                onResume={handleResumeCampaign}
            /> : <CampaignStepper
                nextStepValid={validateAll(isStepValid[steps[activeStep]])}
                steps={steps}
                allowedSteps={allowedSteps}
                activeStep={activeStep}
                setActiveStep={setActiveStep}
                previewCampaign={handleShowSummary}
                heading={stepperHeading}>
                {renderStep()}
            </CampaignStepper>}
    </>
}

export default CreateCampaigns